import { Text } from '@belong/ui';
import { formatFirstLine } from 'utils/formatAddress';

const ADDRESS_ICON_SRC =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/improvement-reports/ic_improvement_address.svg';

type Props = {
  address: unknown;
  unitNumber?: string;
  /**
   * Rendered after the street line, separated by a single space. Any other
   * separator (the walkthrough's middot, say) is the caller's to supply -
   * onboarding's 'Quality Plan' reads as part of the title, not a second
   * clause, so a middot cannot be hardcoded here.
   */
  suffix: string;
};

export function IntroAddressHeader({ address, unitNumber, suffix }: Props) {
  if (!address) return null;

  return (
    <div className="mb-lg mt-2xl flex items-center justify-start gap-xs md:justify-center">
      <img
        src={ADDRESS_ICON_SRC}
        alt=""
        className="h-[30px] w-[24px] shrink-0"
      />
      <Text
        fontWeight="semibold"
        variant="body"
        className="text-left md:text-center"
      >
        {formatFirstLine(address, unitNumber)} {suffix}
      </Text>
    </div>
  );
}
